module.exports = __webpack_public_path__ + "img/9788997581030.f6f0348f.jpg";